import angular from 'angular';

angular.module('fg').component('fgFieldIcon', {
  bindings: {
    iconClass: '<',
    size: '@'
  },
  controller: function () {
    this.$onInit = function () {
      this.size = this.size || 'medium';
    };
  },
  templateUrl: 'angular-form-gen/field-icon/field-icon.ng.html'
});
